<template>
  <div class="p-grid data-table data-table-list">
    <div class="p-col-12">
      <div class="card card-w-title">
        <DataTable
          :value="txs"
          class="p-datatable-responsive"
          :paginator="true"
          :rows="10"
          :filters="filters"
          :autoLayout="true"
        >
          <template #header>
            <h2>List of BTC transactions</h2>
          </template>

          <Column field="wallet_addr" header="Wallet" :sortable="true">
            <template #body="slotProps">
              <span>{{ slotProps.data.wallet_addr }}</span>
            </template>
          </Column>
          <Column field="tx_time" header="Transaction time" :sortable="true">
            <template #body="slotProps">
              <span class="time">{{ formatDate(slotProps.data.tx_time) }}</span>
            </template>
          </Column>
          <Column field="payment_address" header="Payment address" :sortable="true">
            <template #body="slotProps">
              <span class="payment-address">{{ slotProps.data.payment_address }}</span>
            </template>
          </Column>
          <Column field="value" header="Amount" :sortable="true">
            <template #body="slotProps">
              <span>{{ slotProps.data.value }}</span>
            </template>
          </Column>
          <Column field="confirmations" header="Confirmations" :sortable="true">
            <template #body="slotProps">
              <span>{{ slotProps.data.confirmations }}</span>
            </template>
          </Column>

          <Column field="actions" header="Actions" :sortable="true" filterMatchMode="in">
            <template #body="slotProps">
              <Button
                class="btn-primary"
                label="Show Details"
                @click="openDialog(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <Dialog :header="title" :visible.sync="display" :style="{ width: '50vw' }" :modal="true">
      <div class="content-data">
        <h4>Purchase data</h4>
        <div class="data-item">
          <p>Payment address</p>
          <p>{{ activeRow.payment_address }}</p>
        </div>
        <div class="data-item">
          <p>Transaction ID</p>
          <p>{{ activeRow.tx_id }}</p>
        </div>
        <div class="data-item">
          <p>Output no</p>
          <p>{{ activeRow.output_no }}</p>
        </div>
        <div class="data-item">
          <p>Script asm</p>
          <p>{{ activeRow.script_asm }}</p>
        </div>
        <div class="data-item">
          <p>Script hex</p>
          <p>{{ activeRow.script_hex }}</p>
        </div>
        <div class="data-item">
          <p>Value</p>
          <p>{{ activeRow.value }}</p>
        </div>
        <div class="data-item">
          <p>Confirmations</p>
          <p>{{ activeRow.confirmations }}</p>
        </div>
        <div class="data-item">
          <p>Bank Account</p>
          <p>{{ activeRow.bank_account }}</p>
        </div>
        <div class="data-item">
          <p>Transaction time</p>
          <p>{{ activeRow.tx_time }}</p>
        </div>
        <div class="data-item">
          <p>Wallet name</p>
          <p>{{ activeRow.wallet_name }}</p>
        </div>
        <div class="data-item">
          <p>Wallet address</p>
          <p>{{ activeRow.wallet_addr }}</p>
        </div>
        <div class="data-item">
          <p>Active</p>
          <p>{{ activeRow.active }}</p>
        </div>
      </div>
      <template #footer>
        <div class="p-grid">
          <div class="p-md-6 p-offset-6">
            <Button label="Close" @click="closeDialog()" icon="pi pi-times" class="p-button" />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import BTCTransactionsService from "../../../service/BTCTransactionsService";

export default {
  data() {
    return {
      txs: null,
      editingCellRows: {},
      editingRows: [],
      filters: {},
      activeRow: {},
      display: false,
      title: "",
      message: "Test message"
      // columns: null
    };
  },
  async created() {
    this.$store.commit('setPageTitle', {pageTitle: 'BTC Transactions'});
    this.btctxService = new BTCTransactionsService();
    this.originalRows = {};
    await this.getTransactions();
    setInterval(async () => {
      await this.getTransactions();
    }, 10000);
  },
  async mounted() {},
  methods: {
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        hours = "" + d.getHours(),
        mins = "" + d.getMinutes();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      if (hours.length < 2) hours = "0" + hours;
      if (mins.length < 2) mins = "0" + mins;

      return [year, month, day].join("-") + " " + hours + ":" + mins;
    },
    openDialog(purchase) {
      this.display = true;
      this.activeRow = purchase;
      this.title = "Purchase data for package: " + purchase.package_name;
    },
    linkToPurchase(purchase) {
       this.$router.push({
            name: "reports-btcpurchases",
            params: { purchase: purchase }
          });
    },
    closeDialog() {
      this.display = false;
      this.documents = [];
    },
    async getTransactions() {
      var temp = await this.btctxService.getAllTransactions();
      this.txs = temp.data.txs;
    }
  }
};
</script>

<style scoped></style>
